export enum EntityTab {
  Result = 'result',
  ProvidedInfo = 'providedInfo',
  Note = 'note'
}
